import { GalleryCardImage } from "styles/jss/PhotoGallery.styles";
import NextImage from "../../NextImage";
import useWindowSize from "utils/hooks/useWindowSize";

export default function GalleryCard(props) {
  const { formats, caption, overlay, onClick } = props;
  const { width } = useWindowSize();

  const size = {
    width: width > 900 ? 280 : 249,
    height: width > 900 ? 400 : 349,
    ...props?.size,
  };

  return (
    <GalleryCardImage width={size.width} height={size.height} onClick={onClick}>
      <NextImage
        layout={"responsive"}
        objectFit={"cover"}
        src={formats.small.url}
        alt={caption}
        loading="lazy"
        placeholder="blur"
        {...size}
      />
      {overlay && overlay}
    </GalleryCardImage>
  );
}
